#import "./DataAccessPolicyFields.graphql"

query DataAccessPolicies(
  $first: Int
  $after: Cursor
  $orderBy: [DataAccessPoliciesOrderBy!]
  $filter: DataAccessPolicyFilter
) {
  dataAccessPolicies(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    nodes {
      ...DataAccessPolicyFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
